import React from 'react'
import popup from '~/views/Popup/popup'

const SuspendedSubscriptionInfo = (props) => {
    return (
      <section>
        <div className="title site-color">Subscription</div>
        <div className="detail">
          <div className="main">
            <div className="next-step">
              Account has been suspended.
            </div>
          </div>
          <div className="buttons">
            <a href="/viewplans" className="button">Subscribe Now</a>
            { this.props.transaction && 
              <div 
                className="button" 
                onClick={ _ => popup.billingHistory() }>
                Billing History
              </div> }
          </div>
        </div>
        <div className="clearfix"></div>
      </section>)
  }

export default SuspendedSubscriptionInfo;